import { getQuestion, sendAnswer } from '@/apis/application';
import { ApplicantDetails } from '@/types/ApplicantDetails';
import { AssessmentState, QuestionnaireState } from '@/types/Question';
import { Applicant, Questions } from '@/types/Question/Assessment';
import { QuestionnaireData } from '@/types/Question/Questionnaire';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const initialState: AssessmentState = {
  loading: false,
  error: false,
  appId: '',
  refId: '',
  selectedApplicant: null,
  applicants: [],
  questionList: {
    data: {
      applicants: [],
    },
  },
  questions: [],
};

// export const initialState: AssessmentState = {
//   loading: false,
//   error: false,
//   appId: 'EDP',
//   refId: 'LF0000000002',
//   selectedApplicant: 'Self',
//   applicants: [
//     {
//       id: 1,
//       answers: [
//         {
//           questionId: '6fafe7ed-50a0-483a-84af-f9a89d35b12c',
//           header: 'Health & Medical Questions',
//           answer: 'N',
//         },
//         {
//           questionId: '80922c6e-33c5-4bf3-bb2d-ec27f24ecfbd',
//           header: 'Health & Medical Questions',
//           answer: 'N',
//         },
//         {
//           questionId: 'a05fd5b9-f942-4298-b4eb-ec5342c0497a',
//           header: 'Health & Medical Questions',
//           answer: 'N',
//         },
//         {
//           questionId: 'de1d80be-73f8-47fd-8ee4-a1215a3f9fbe',
//           header: 'Height & Weight',
//           answer: '156',
//         },
//         {
//           questionId: 'ab218656-7615-4a59-99d1-72c62b7f1311',
//           header: 'Height & Weight',
//           answer: '80',
//         },
//       ],
//     },
//     {
//       id: 2,
//       answers: [
//         {
//           questionId: 'c9e35474-18e4-45da-b09d-75d4de7051c7',
//           header: 'Health & Medical Questions',
//           answer: 'N',
//         },
//         {
//           questionId: 'e328e29e-5b79-43e5-801d-000b7b4f3537',
//           header: 'Health & Medical Questions',
//           answer: 'N',
//         },
//         {
//           questionId: '5ed8c913-7605-4693-95bb-707d38ae151a',
//           header: 'Health & Medical Questions',
//           answer: 'N',
//         },
//         {
//           questionId: '2842e7b3-786f-4d77-92cf-bba5d9a864f2',
//           header: 'Height & Weight',
//           answer: '156',
//         },
//         {
//           questionId: '27c4bb8f-b26a-4e3b-ab35-6153883518da',
//           header: 'Height & Weight',
//           answer: '80',
//         },
//       ],
//     },
//   ],
//   questionList: {
//     data: {
//       applicants: [],
//     },
//   },
//   questions: [
//     {
//       questionNo: 1,
//       questionType: "bmi",
//       question: 'Height',
//       header: 'Height & Weight',
//       data: [
//         {
//           questionId: '597a2d3d-8777-46a4-8101-8abc8c5e979d',
//           applicantId: 1,
//           idNo: '890101123457',
//           gender: 'M',
//           relationship: '001',
//         },
//         {
//           questionId: '9007d9ac-58b5-48e4-b167-2966701ca2ee',
//           applicantId: 2,
//           idNo: '890101123458',
//           gender: 'F',
//           relationship: '003',
//         },
//         {
//           questionId: 'abcd',
//           applicantId: 3,
//           idNo: '890101123459',
//           gender: 'M',
//           relationship: '002',
//         },
//       ],
//     },
//     {
//       questionNo: 2,
//       questionType: "bmi",
//       question: 'Weight',
//       header: 'Height & Weight',
//       data: [
//         {
//           questionId: '75ba3fbf-1977-44e2-9142-56e978096a63',
//           applicantId: 1,
//           idNo: '890101123457',
//           gender: 'M',
//           relationship: '001',
//           answer: "N"
//         },
//         {
//           questionId: '24db0abb-1f7a-4e24-b48e-b7ee47d1ebbe',
//           applicantId: 2,
//           idNo: '890101123458',
//           gender: 'F',
//           relationship: '003',
//         },
//         {
//           questionId: 'abcd',
//           applicantId: 3,
//           idNo: '890101123459',
//           gender: 'M',
//           relationship: '002',
//         },
//       ],
//     },
//     {
//       questionNo: 3,
//       questionType: "health",
//       question:
//         'Has any of your application for life/family takaful/health/critical illness/accident or disability insurance/takaful been:\na. Declined\nb. Deferred\nc. Accept with revised premiums/contributions; or\nd. Accept with revised terms\ndue to health reason or have you made any claim from any of your policy/certificate? \n',
//       header: 'Health & Medical Questions',
//       data: [
//         {
//           questionId: '4203363c-2587-4755-8053-020ec0205ce4',
//           applicantId: 1,
//           idNo: '890101123457',
//           gender: 'M',
//           relationship: '001',
//         },
//         {
//           questionId: 'b0a63d90-c5bf-452e-8dc5-ed10287d6245',
//           applicantId: 2,
//           idNo: '890101123458',
//           gender: 'F',
//           relationship: '003',
//         },
//       ],
//     },
//     {
//       questionNo: 4,
//       questionType: "health",
//       question:
//         'In the past 2 years, have you ever\na. undergone or been advised to undergo diagnostic tests (other than routine health screening)\nb. Been prescribed medication or received treatment (other than for flu or cough) lasting longer than 6 consecutive days\nc. been hospitalized due to illness for more than 5 days; or\nd. Been advised to seek further specialist medical attention?\n',
//       header: 'Health & Medical Questions',
//       data: [
//         {
//           questionId: 'b0a63d90-c5bf-452e-8dc5-ed10287d6245',
//           applicantId: 1,
//           idNo: '890101123457',
//           gender: 'M',
//           relationship: '001',
//         },
//         {
//           questionId: 'abcde',
//           applicantId: 2,
//           idNo: '890101123458',
//           gender: 'F',
//           relationship: '003',
//         },
//       ],
//     },
//   ]
// };

const assessmentSlice = createSlice({
  name: 'assessmentState',
  initialState,
  reducers: {
    resetQuestionState: () => {
      return initialState;
    },
    addQuestionData: (state, action: PayloadAction<QuestionnaireState>) => {
      state.questionList.data = action.payload.data;
    },
    updateSelectedApplicant: (state, action: PayloadAction<number>) => {
      state.selectedApplicant = action.payload;
    },
    updateAnswer: (state, action: PayloadAction<any>) => {
      state.questions.forEach((e) => {
        if (
          e.questionNo === action.payload.questionNo &&
          e.questionType === action.payload.questionType
        ) {
          e.data.forEach((i) => {
            if (i.applicantId === action.payload.applicantId) {
              i.answer = action.payload.answer;
            }
          });
        }
      });
    },
    mapQuickQuoteToAssessment: (state, action) => {
      // to map gender and other prop from applicantData
      const applicantData: ApplicantDetails[] = action.payload.applicantData;
      const questionsData: Questions[] = action.payload.questions;
      questionsData.forEach((question, questionIndex) => {
        question.data.forEach((dataItem, dataIndex) => {
          const applicant = applicantData.find(
            (applicant) => applicant.id === dataItem.applicantId,
          );
          if (applicant) {
            state.questions[questionIndex].data[dataIndex].idNo =
              applicant.idNo;
            state.questions[questionIndex].data[dataIndex].gender =
              applicant.gender;
            state.questions[questionIndex].data[dataIndex].relationship =
              applicant.relationship;
          }
        });
      });
    },
    mapQuestions: (state, action) => {
      const data = action.payload.data as QuestionnaireData;
      const arrayQuestion = [];

      data.applicants.forEach((applicant) => {
        applicant.questionDetails.forEach((detail) => {
          let question = arrayQuestion.find(
            (q) => q.questionNo === detail.questionNo,
          );

          if (!question) {
            question = {
              questionNo: detail.questionNo,
              questionType:
                detail.questionNo === 1 || detail.questionNo === 2
                  ? 'bmi'
                  : 'health',
              question: detail.question,
              header: detail.header,
              data: [],
            };
            arrayQuestion.push(question);
          }

          question.data.push({
            questionId: detail.questionId,
            applicantId: applicant.id,
          });
        });
      });
      state.questions = arrayQuestion;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getQuestion.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getQuestion.fulfilled, (state) => {
        state.loading = false;
        state.error = false;
      })
      .addCase(getQuestion.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
    builder
      .addCase(sendAnswer.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(sendAnswer.fulfilled, (state, action) => {
        state.applicants = action.payload.data?.applicants as Applicant[];
        state.loading = false;
        state.error = false;
      })
      .addCase(sendAnswer.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const {
  addQuestionData,
  updateSelectedApplicant,
  updateAnswer,
  mapQuickQuoteToAssessment,
  mapQuestions,
  resetQuestionState,
} = assessmentSlice.actions;

export default assessmentSlice.reducer;
